export const calculateTypingDuration = (
	text: string,
	charactersPerSecond?: number
) => {
	charactersPerSecond = charactersPerSecond || 30;
	const totalDuration = text.length / charactersPerSecond;

	return totalDuration;
};
